import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmAlert = ({ message, onOK, onCancel, show }) => {
  return (
    <Modal show={show} onBackdropClick={onCancel} >
      <Modal.Header closeButton>
        <Modal.Title>Delete Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onOK}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmAlert;
